import React from 'react';
import { Link } from 'react-router-dom'

function LogoImage(props) {
    return <Link to={`${process.env.PUBLIC_URL}/`}  className="logo">
        <img  src={`${process.env.PUBLIC_URL}/assets/images/icon/Naswiz-logo.png`} alt="Logo" />
    </Link>;
}

export default LogoImage;